// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inv-sel-cbo {\n  width: 120px;\n}\n\n.inv-sel-btn {\n  width: 15px;\n  height: 30px;\n}\n\n.inv-sel-adv-tb {\n  width: 400px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
